module.exports = __webpack_public_path__ + "media/assets/images/snow_later_will_rain-96743840e46fd0d507fb6c08cc0be42f.png";